document.addEventListener("DOMContentLoaded", function() {
    let menu = document.querySelector(".m-header__menu"); // Menu selector
    let header = document.querySelector(".m-header.m-header.transparent-on-top"); // Header selector
    let bodyElem = document.querySelector("body#m-theme")
    function toggleHeaderClass() {
        if (menu.classList.contains("active")) {
            header.classList.add("new-class"); // Class add karo
            bodyElem.classList.add("body_noScroll") // body mein class add
        } else {
            header.classList.remove("new-class"); // Class remove karo
            bodyElem.classList.remove("body_noScroll")
        }
    }

    // MutationObserver: Yeh continuously check karega ke `active` class lagi hai ya nahi
    let observer = new MutationObserver(toggleHeaderClass);
    observer.observe(menu, { attributes: true, attributeFilter: ["class"] });

    // Pehli baar bhi check kar lo
    toggleHeaderClass();
});


document.addEventListener('DOMContentLoaded', function () {
  function updatePrice() {
    let selectedRadio = document.querySelector('.sls-option:checked');

    if (!selectedRadio) {
      const activeContainer = document.querySelector('.sls-option-container.sls-active');
      if (activeContainer) {
        selectedRadio = activeContainer.querySelector('.sls-option');
      }
    }

    if (selectedRadio) {
      const container = selectedRadio.closest('.sls-option-container');
      if (container) {
        const priceSpan = container.querySelector('.money.conversion-bear-money.seal-money.ht-money');
        if (priceSpan) {
          const addToCartPrice = document.querySelector('.m-add-to-cart--price');
          if (addToCartPrice) {
            addToCartPrice.textContent = `- ${priceSpan.textContent}`;
          }
        }
      }
    }
  }

  document.addEventListener('change', function (e) {
    if (e.target.classList.contains('sls-option')) {
      setTimeout(updatePrice, 100);
    }
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('.sls-option-container')) {
      setTimeout(updatePrice, 100);
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('select[name="subs_interval"]')) {
      setTimeout(updatePrice, 100);
    }
  });

  updatePrice();
});


